/* eslint-disable max-classes-per-file */
import { ILoggingContext } from '../interfaces/IPortalServiceResult';
import { BehaviorSubject } from 'rxjs';
import type { ApplicationInsights as oneDSAI } from '@microsoft/1ds-analytics-web-js';

export class LoggerVariables {
    public static isGitMode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public static gitProvider: string = undefined;
    public static resourceCountAfterLoading: number = 0;
}

declare class OneDSApplicationInsights extends oneDSAI {
    public loggingContext: ILoggingContext;
    public updateEndpointUrl(url: string): void; // This function is not in the official 1DSSDK. We applied patches to implement it. See index.html
}
declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    export namespace Microsoft.ApplicationInsights {
        interface IAppInsights {
            /** ADF-specific logging context information. */
            loggingContext: ILoggingContext;
        }
    }

    // eslint-disable-next-line no-var
    var oneDSWeb: OneDSApplicationInsights;
}

/**
 * Local AI namespace that provides fallback before ai.0.js has been downloaded.
 * Also provides dummy implementation for unit tests.
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AILocal {
    export enum SeverityLevel {
        Verbose = 0,
        Information = 1,
        Warning = 2,
        Error = 3,
        Critical = 4
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!(window as any).AI) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).AI = AILocal as Partial<typeof AI> as unknown as typeof AI;
}

export function getSessionIdFromAppInsights(appInsights: Microsoft.ApplicationInsights.IAppInsights): string {
    // In case appInsights is only a local dummy object.
    if (appInsights.context && appInsights.context.session && appInsights.context.session.id) {
        return appInsights.context.session.id;
    }
    // AI 1.x SDK does not expose automatic session ID. We need to hack into it.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sessionManager = appInsights.context && (appInsights.context as any)._sessionManager;
    if (sessionManager) {
        return sessionManager.automaticSession && sessionManager.automaticSession.id;
    }
    return undefined;
}

export function getLoggingKey(oneDSWeb: OneDSApplicationInsights): string {
    return oneDSWeb.loggingContext?.loggingKey;
}

export function getSessionIdFromOneDS(oneDSWeb: OneDSApplicationInsights): string {
    try {
        const session = oneDSWeb.getPropertyManager().getPropertiesContext().session;
        return session.getId();
    } catch (error) {
        return undefined;
    }
}

export function getOperationIdFromOneDS(oneDSWeb: OneDSApplicationInsights): string {
    try {
        // @ts-ignore
        return oneDSWeb.loggingContext.operationId || '';
    } catch (error) {
        return '';
    }
}